import React from 'react';
import i18next from 'i18next';

import type { ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import SocialNetworkView from './view/SocialNetworkView';
import buttons from './SocialNetworksButtons';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	routes: [
		{
			path: 'socialnetworks/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'socialnetworks'),
			element: (
				<ViewPage
					module="socialnetworks"
					content={{ type: 'tabs', tabs: SocialNetworkView }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
